import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import Tech from "./technical/technicalSkills";

/**
 * Technical Component for rendering child tech
 */
class TechSkill extends Component {
  render() {
    return (
      <Container
        style={{ maxWidth: "60%", marginTop: "40px !important" }}
        className="card container-card migrator-mt personalDetails-div-1 contact-res"
      >
        <i
          className="material-icons contact-cancel-button pointer"
          onClick={this.props.back}
        >
          cancel
        </i>
        <Row>
          <Col md="12" className=" profile-contact-details-col mx-auto">
            <Tech />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default TechSkill;
